/**
 * One capture, in flight between the tab tap that took it and the report
 * screen that consumes it. A module singleton rather than router state: a File
 * has no business in browser history.
 */

/** A capture from earlier in the session must never attach itself to a later, unrelated report. */
export const PENDING_MAX_AGE_MS = 2 * 60 * 1000;

let pending: { file: File; at: number } | null = null;

export function setPendingCapture(file: File): void {
  pending = { file, at: Date.now() };
}

/** Drains the stash: the same capture is never handed out twice. */
export function takePendingCapture(): File | null {
  if (!pending) return null;
  const { file, at } = pending;
  pending = null;
  return Date.now() - at > PENDING_MAX_AGE_MS ? null : file;
}
